import { getSubmittableFileDefinitions } from 'utils/dictionaryHelpers';
import AnnotationIcon from 'components/icons/AnnotationIcon';
import ArrowLeftIcon from 'components/icons/ArrowLeftIcon';
import BiospecimenIcon from 'components/icons/BiospecimenIcon';
import CaseIcon from 'components/icons/CaseIcon';
import ClinicalIcon from 'components/icons/ClinicalIcon';
import CloseIcon from 'components/icons/CloseIcon';
import DashboardIcon from 'components/icons/DashboardIcon';
import DownloadIcon from 'components/icons/DownloadIcon';
import ErrorIcon from 'components/icons/ErrorIcon';
import TrashIcon from 'components/icons/TrashIcon';
import GDCAPIIcon from 'components/icons/GDCAPIIcon';
import GDCAppsMenuIcon from 'components/icons/GDCAppsMenuIcon';
import GDCDataPortalIcon from 'components/icons/GDCDataPortalIcon';
import GDCDataTransferToolIcon from 'components/icons/GDCDataTransferToolIcon';
import GDCDocsIcon from 'components/icons/GDCDocsIcon';
import GDCLegacyArchiveIcon from 'components/icons/GDCLegacyArchiveIcon';
import GDCPublicationsIcon from 'components/icons/GDCPublicationsIcon';
import GDCSubmissionPortalIcon from 'components/icons/GDCSubmissionPortalIcon';
import GDCWebsiteIcon from 'components/icons/GDCWebsiteIcon';
import HelpIcon from 'components/icons/HelpIcon';
import OpenModalIcon from 'components/icons/OpenModalIcon';
import ReadGroupIcon from 'components/icons/ReadGroupIcon';
import ReleasedIcon from 'components/icons/ReleasedIcon';
import ReportIcon from 'components/icons/ReportIcon';
import SearchIcon from 'components/icons/SearchIcon';
import SubmittedIcon from 'components/icons/SubmittedIcon';
import TransactionIcon from 'components/icons/TransactionIcon';
import TreeIcon from 'components/icons/TreeIcon';
import UploadIcon from 'components/icons/UploadIcon';
import ValidIcon from 'components/icons/ValidIcon';
import WaitIcon from 'components/icons/WaitIcon';
import WarningIcon from 'components/icons/WarningIcon';

export {
  AnnotationIcon,
  ArrowLeftIcon,
  BiospecimenIcon,
  CaseIcon,
  ClinicalIcon,
  CloseIcon,
  DashboardIcon,
  DownloadIcon,
  ErrorIcon,
  GDCAPIIcon,
  GDCAppsMenuIcon,
  GDCDataPortalIcon,
  GDCDataTransferToolIcon,
  GDCDocsIcon,
  GDCLegacyArchiveIcon,
  GDCPublicationsIcon,
  GDCSubmissionPortalIcon,
  GDCWebsiteIcon,
  HelpIcon,
  OpenModalIcon,
  ReadGroupIcon,
  ReleasedIcon,
  ReportIcon,
  SearchIcon,
  SubmittedIcon,
  TransactionIcon,
  TrashIcon,
  TreeIcon,
  UploadIcon,
  ValidIcon,
  WaitIcon,
  WarningIcon,
};

export function IconRegistry(entity, defs) {
  const submittableToIcon = getSubmittableFileDefinitions({ defs })
    .reduce((acc, d) => ({ ...acc, [d.id]: ReadGroupIcon }), {});

  const biospecimenToIcon = defs
    .filter(d => d.category === 'biospecimen')
    .reduce((acc, d) => ({ ...acc, [d.id]: BiospecimenIcon }), {});

  const clinicalToIcon = defs
    .filter(d => d.category === 'clinical')
    .reduce((acc, d) => ({ ...acc, [d.id]: ClinicalIcon }), {});

  const entityToIcon = {
    ...submittableToIcon,
    ...biospecimenToIcon,
    ...clinicalToIcon,
    case: CaseIcon,
    annotation: AnnotationIcon,
  };
  return entityToIcon[entity] || CaseIcon;
}
